<div class="table-container">
  @if (showClearAllFilters) {
    <div class="button-container">
      <button (click)="clearAllFilters()"
        class="btn-secondary clear-all-filters-button"
        data-cy="user-list-clear-all-filters-button">Clear all filters
      </button>
    </div>
  }

  <table class="list-table" data-cy="membership-users-table">
    <thead>
      <tr class="list-row">
        <th class="list-header-element name">
          <div class="label-and-filter">
            <div class="label-and-filter-column">
              <span (click)="sortingBy(UserTableFilterColumn.IDENTIFICATION, state.isNameArrowUp); arrowToggle()"
                class="sortable"
                data-cy="users-table-header-arrow-button-partner">
                <app-tooltip message="Partner">
                  <span class="sortable" data-cy="users-table-header-name">Name</span>
                </app-tooltip>
              </span>
              <app-tooltip [disable]="userSearchCriteriaService.sortedBy !== UserTableFilterColumn.PARTNER"
                [dynamic]="false"
                message="Sort">
                @if (userSearchCriteriaService.sortedBy === UserTableFilterColumn.IDENTIFICATION) {
                  <span (click)="sortingBy(UserTableFilterColumn.IDENTIFICATION, state.isNameArrowUp); arrowToggle()"
                    [ngClass]="{'iwp-icon-gen_arrow_down': !state.isNameArrowUp, 'iwp-icon-gen_arrow_up': state.isNameArrowUp}"
                    class="sortable-arrow"
                    data-cy="users-table-header-arrow-partner">
                  </span>
                }
              </app-tooltip>
            </div>

            <app-simple-filter #userFilterComponent
              (filterEvent)="onFilterChange($event)"
              [filterName]="UserTableFilterColumn.IDENTIFICATION"
              [placeHolder]="'Search users'"
            formatWithoutCode="true"></app-simple-filter>
          </div>
        </th>
        <th class="list-header-element role">
          <div class="label-and-filter">
            <app-tooltip message="Roles">
              <span data-cy="users-table-header-roles">Roles</span>
            </app-tooltip>
            <app-code-filter #roleFilterComponent
              (filterEvent)="onFilterChange($event)"
              [codes]="roleFilterOptions"
              [filterName]="UserTableFilterColumn.ROLE"
              [placeHolder]="'Search roles'"
            data-cy="users-table-roles-filter"></app-code-filter>
          </div>
        </th>

        @if (state?.showPartnerColumn) {
          <th class="list-header-element partner">
            <div class="label-and-filter">
              <app-tooltip message="Partners">
                <span data-cy="users-table-header-partners">Partners</span>
              </app-tooltip>
              <app-code-filter
                #partnerComponent
                (filterEvent)="onFilterChange($event)"
                [codes]="partnerFilterOptions"
                [filterName]="UserTableFilterColumn.PARTNER"
                [placeHolder]="'Search partners'"
              data-cy="users-table-partners-filter"></app-code-filter>
            </div>
          </th>
        }

        @if (state?.showSupplyingPackingPlantsColumn) {
          <th class="list-header-element supplying-packing-plant">
            <div class="label-and-filter">
              <app-tooltip message="Supplying packing plant">
                <span data-cy="users-table-header-supplying-packing-plant">Supplying packing plant</span>
              </app-tooltip>
              <app-code-filter
                #supplyingPackingPlantComponent
                (filterEvent)="onFilterChange($event)"
                [codes]="supplyingPackingPlantsFilterOptions"
                [filterName]="UserTableFilterColumn.SUPPLYING_PACKING_PLANT"
                [placeHolder]="'Search supplying packing plant'"
              data-cy="users-table-supplying-packing-filter"></app-code-filter>
            </div>
          </th>
        }

        @if (state?.showTechnicianGroupsColumn) {
          <th class="list-header-element technician-group">
            <div class="label-and-filter">
              <app-tooltip message="Technician groups">
                <span data-cy="users-table-header-technicians">Technician groups</span>
              </app-tooltip>
              <app-code-filter
                #technicianGroupComponent
                (filterEvent)="onFilterChange($event)"
                [codes]="techniciansFilterOptions"
                [filterName]="UserTableFilterColumn.TECHNICIAN"
                [formatWithoutCode]="true"
                [placeHolder]="'Search technician groups'"
                class="filter-button"
              data-cy="users-table-technician-groups-filter"></app-code-filter>
            </div>
          </th>
        }

        @if (state?.showSupplierColumn) {
          <th class="list-header-element supplier">
            <div class="label-and-filter">
              <app-tooltip message="Suppliers">
                <span data-cy="users-table-header-suppliers">Suppliers</span>
              </app-tooltip>
              <app-code-filter
                #supplierComponent
                (filterEvent)="onFilterChange($event)"
                [codes]="suppliersFilterOptions"
                [filterName]="UserTableFilterColumn.SUPPLIER"
                [formatWithoutCode]="true"
                [placeHolder]="'Search supplier'"
                class="filter-button"
              data-cy="users-table-supplier-filter"></app-code-filter>
            </div>
          </th>
        }

        @if (state?.showCustomerColumn) {
          <th class="list-header-element customer">
            <div class="label-and-filter">
              <app-tooltip message="Customers">
                <span data-cy="users-table-header-customers">Customers</span>
              </app-tooltip>
              <app-code-filter
                #customerComponent
                (filterEvent)="onFilterChange($event)"
                [codes]="customersFilterOptions"
                [filterName]="UserTableFilterColumn.CUSTOMER"
                [formatWithoutCode]="true"
                [placeHolder]="'Search customer'"
                class="filter-button"
              data-cy="users-table-customer-filter"></app-code-filter>
            </div>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (tableUser of usersList; track tableUser) {
        <tr class="list-row users-table-row" data-cy="users-table-row">
          <td class="list-element name">
            <app-tooltip message="{{tableUser.user | userDisplay}}"
              placement="top-left">
              <span data-cy="users-table-element-name">{{tableUser.user | userDisplay}}</span>
            </app-tooltip>
          </td>
          <td class="list-element users-table-element users-table-role-element" data-cy="users-table-element-roles">
            <div class="users-table-cell-wrapper">
              <div class="users-table-add-button-wrapper">
                <app-tooltip [dynamic]="false" message="Add role">
                  @if (state?.canGrantRole) {
                    <button (click)="addNewRole(tableUser)"
                      [disabled]="!tableUser.canAddRoles"
                      class="btn-secondary add-button iwp-icon-gen_plus"
                      data-cy="users-table-add-role-button" data-ut="users-table-add-role-button"
                    type="button"></button>
                  }
                </app-tooltip>
              </div>
              <div class="users-table-select-in-table-wrapper"
                data-cy="users-table-select-in-table-wrapper">
                @for (role of tableUser.user.roles; track role) {
                  <span data-ut="users-table-element-roles">
                    <app-select-in-table
                      (closeClickEvent)="revokeRole(tableUser, role)"
                      (selectedDropdownOption)="grantRole(tableUser, $event)"
                        [displayObject]="{
                                            string: role.role.code,
                                            expirationDate: role.expiresOn,
                                            maxNumberOfDays: role.role.maxNumberOfDays,
                                            expirationWarning: role.expirationWarning,
                                            expirationWarningDays: role.role.expirationWarningDays
                                        }"
                      [dropdownOptions]="rolesDropdownOptions"
                      [dropdownType]="dropdownType.DESCRIPTION"
                      [enableDelete]="$safeNavigationMigration(state?.canRevokeRole)"
                      [showDateInput]="true"
                      [styleObject]="rolesColor"
                      [success]="submittedWithSuccess">
                    </app-select-in-table>
                  </span>
                }
              </div>
            </div>
          </td>
          @if (state?.showPartnerColumn) {
            <td class="list-element users-table-element users-table-partner-element"
              data-cy="users-table-cell-partner">
              <div class="users-table-cell-wrapper">
                <div class="users-table-add-button-wrapper">
                  <app-tooltip [dynamic]="false" message="Add partner">
                    @if (state?.canAddPartner) {
                      <button (click)="addNewElementToEntityGroup(tableUser, GroupTypeEnum.PARTNER)"
                        [disabled]="!tableUser.canAddPartners"
                        class="btn-secondary add-button iwp-icon-gen_plus"
                        data-cy="users-table-add-partner-button"
                      type="button"></button>
                    }
                  </app-tooltip>
                </div>
                <div class="users-table-select-in-table-wrapper">
                  @for (partner of getUserPartners(tableUser); track partner) {
                    <span data-cy="users-table-element-partners">
                      <app-chip-selector (close)="closeEntityGroup(tableUser, $event, GroupTypeEnum.PARTNER)"
                        (delete)="deleteEntityGroup(tableUser, $event, GroupTypeEnum.PARTNER)"
                        [zones]="partnerZones(partner, tableUser)"
                      [isDeleteAvailable]="$safeNavigationMigration(state?.canAddPartner)"></app-chip-selector>
                    </span>
                  }
                </div>
              </div>
            </td>
          }
          @if (state?.showSupplyingPackingPlantsColumn) {
            <td class="list-element users-table-element users-table-supplying-packing-plant-element"
              data-cy="users-table-cell-supplying-packing-plant">
              <div class="users-table-cell-wrapper">
                <div class="users-table-add-button-wrapper">
                  <app-tooltip [dynamic]="false" message="Add supplying packing plant">
                    @if (state?.canAddSupplyingPackingPlant) {
                      <button (click)="addNewElementToEntityGroup(tableUser, GroupTypeEnum.PLANNER)"
                        [disabled]="!tableUser.canAddSupplyingPackingPlants"
                        class="btn-secondary add-button iwp-icon-gen_plus"
                        data-cy="users-table-add-supplying-packing-plant-button"
                      type="button"></button>
                    }
                  </app-tooltip>
                </div>
                <div class="users-table-select-in-table-wrapper">
                  @for (plant of getUserSupplyingPackingPlants(tableUser); track plant) {
                    <span
                      data-cy="users-table-element-supplying-packing-plant">
                      <app-chip-selector
                        (close)="closeEntityGroup(tableUser, $event, GroupTypeEnum.PLANNER)"
                        (delete)="deleteEntityGroup(tableUser, $event, GroupTypeEnum.PLANNER)"
                        [zones]="supplyingPackingPlantZones(plant, tableUser)"
                      [isDeleteAvailable]="$safeNavigationMigration(state?.canAddSupplyingPackingPlant)"></app-chip-selector>
                    </span>
                  }
                </div>
              </div>
            </td>
          }
          @if (state?.showTechnicianGroupsColumn) {
            <td class="list-element users-table-element users-table-technician-groups-element"
              data-cy="users-table-cell-technician-groups">
              <div class="users-table-cell-wrapper">
                <div class="users-table-add-button-wrapper">
                  <app-tooltip [dynamic]="false" message="Add technician group">
                    @if (state?.canAddTechnicianGroup) {
                      <button (click)="addNewElementToEntityGroup(tableUser, GroupTypeEnum.TECHNICIAN)"
                        [disabled]="!tableUser.canAddTechnicianGroups"
                        class="btn-secondary add-button iwp-icon-gen_plus"
                        data-cy="users-table-add-technician-groups-button"
                      type="button"></button>
                    }
                  </app-tooltip>
                </div>
                <div class="users-table-select-in-table-wrapper">
                  @for (technicianGroup of getUserTechnicianGroups(tableUser); track technicianGroup) {
                    <span
                      data-cy="users-table-element-technician-groups">
                      <app-chip-selector
                        (close)="closeEntityGroup(tableUser, $event, GroupTypeEnum.TECHNICIAN)"
                        (delete)="deleteEntityGroup(tableUser, $event, GroupTypeEnum.TECHNICIAN)"
                        [zones]="technicianGroupsZones(technicianGroup, tableUser)"
                      [isDeleteAvailable]="$safeNavigationMigration(state?.canAddTechnicianGroup)"></app-chip-selector>
                    </span>
                  }
                </div>
              </div>
            </td>
          }
          @if (state?.showSupplierColumn) {
            <td class="list-element users-table-element users-table-suppliers-element"
              data-cy="users-table-cell-suppliers">
              <div class="users-table-cell-wrapper">
                <div class="users-table-add-button-wrapper">
                  <app-tooltip [dynamic]="false" message="Add a supplier">
                    @if (state?.canAddSupplier) {
                      <button (click)="addNewElementToEntityGroup(tableUser, GroupTypeEnum.SUPPLIER)"
                        [disabled]="!tableUser.canAddSuppliers"
                        class="btn-secondary add-button iwp-icon-gen_plus"
                        data-cy="users-table-add-suppliers-button"
                      type="button"></button>
                    }
                  </app-tooltip>
                </div>
                <div class="users-table-select-in-table-wrapper">
                  @for (supplier of getUserSuppliers(tableUser); track supplier) {
                    <span
                      data-cy="users-table-element-suppliers">
                      <app-chip-selector
                        (close)="closeEntityGroup(tableUser, $event, GroupTypeEnum.SUPPLIER)"
                        (delete)="deleteEntityGroup(tableUser, $event, GroupTypeEnum.SUPPLIER)"
                        [zones]="supplierZones(supplier, tableUser)"
                      [isDeleteAvailable]="$safeNavigationMigration(state?.canAddSupplier)"></app-chip-selector>
                    </span>
                  }
                </div>
              </div>
            </td>
          }
          @if (state?.showCustomerColumn) {
            <td class="list-element users-table-element users-table-customers-element"
              data-cy="users-table-cell-customers">
              <div class="users-table-cell-wrapper">
                <div class="users-table-add-button-wrapper">
                  <app-tooltip [dynamic]="false" message="Add a customer">
                    @if (state?.canAddCustomer) {
                      <button (click)="addNewElementToEntityGroup(tableUser, GroupTypeEnum.CUSTOMER)"
                        [disabled]="!tableUser.canAddCustomers"
                        class="btn-secondary add-button iwp-icon-gen_plus"
                        data-cy="users-table-add-customers-button"
                      type="button"></button>
                    }
                  </app-tooltip>
                </div>
                <div class="users-table-select-in-table-wrapper">
                  @for (customer of getUserCustomers(tableUser); track customer) {
                    <span
                      data-cy="users-table-element-customers">
                      <app-chip-selector
                        (close)="closeEntityGroup(tableUser, $event, GroupTypeEnum.CUSTOMER)"
                        (delete)="deleteEntityGroup(tableUser, $event, GroupTypeEnum.CUSTOMER)"
                        [zones]="customerZones(customer, tableUser)"
                      [isDeleteAvailable]="$safeNavigationMigration(state?.canAddCustomer)"></app-chip-selector>
                    </span>
                  }
                </div>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
  @if (spinnerObservable | async) {
    <div class="spinner-container" data-cy="loading-spinner-overlay">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>

@if (usersList?.length == 0) {
  <div class="list-empty">
    <div class="list-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
    <div class="list-empty-description">The membership list is empty</div>
  </div>
}


@if (userSearchCriteriaService.totalResults > userSearchCriteriaService.pageSize) {
  <app-pagination (pageNumber)="changePage($event)"
    [collectionSize]="userSearchCriteriaService.totalResults"
    [pageSize]="userSearchCriteriaService.pageSize"
    [page]="userSearchCriteriaService.pageNumber"
    data-cy="membership-list-pagination">
  </app-pagination>
}


<ng-template #technicianGroups let-description="description" let-name="name">
  <app-technician-groups-tooltip-content [description]="description"
    [name]="name">
  </app-technician-groups-tooltip-content>
</ng-template>
